import { SearchField } from 'modules/domains';
import { ElementType, useElementIndex } from 'modules/queryBuilder/legacyQueryBuilder/contexts';
import { replaceElementAt } from 'utils/arrayHelpers';

import { useRequirementState } from '../useRequirementState';

export type SetConditionFn = (condition: SearchField) => void;

export const useSetCondition = (): SetConditionFn => {
  const [requirement, setRequirement] = useRequirementState();
  const indexToUpdate = useElementIndex(ElementType.Condition);
  return function setCondition(updatedCondition: SearchField) {
    setRequirement({
      ...requirement,
      searchCombo: {
        ...requirement.searchCombo,
        searchQueries: replaceElementAt(
          requirement.searchCombo.searchQueries,
          indexToUpdate,
          updatedCondition,
        ),
      },
    });
  };
};
